let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ltWbW")).then(() => parcelRequire('4q5CG'));